import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../style/colors';
import { actionColor } from '../../style/theme-helpers';
import BaseCard, { BaseCardProps } from './base-card';

export interface ColorfulCardProps extends BaseCardProps {
  variant?: 'experts' | 'learning' | 'technologies' | 'agents' | 'assistance' | 'default';
  active?: boolean;
  children: React.ReactNode;
}

const cardColorVariants = {
  experts: colors.paradiso,
  learning: colors.amberGlow,
  technologies: colors.ametystPurple,
  agents: colors.raspberryPink,
  assistance: colors.hanBlue,
  default: colors.paradiso,
};

const StyledColorfulCard = styled(BaseCard)<ColorfulCardProps>`
  ${props => css`
    background-color: ${cardColorVariants[props.variant || 'default']};
  `}
  ${props => css`
    border: 2px solid ${cardColorVariants[props.variant || 'default']};
  `};
  transition: all 250ms ease;
  cursor: pointer;
  ${props =>
    !props.active &&
    css`
      opacity: 0.3;

      &:hover {
        opacity: 0.5;
      }
    `}
  &:focus-visible {
    border: 2px solid ${actionColor};
  }
`;

const ColorfulCard: React.FC<ColorfulCardProps> = ({ children, ...props }) => {
  return <StyledColorfulCard {...props}>{children}</StyledColorfulCard>;
};

export default ColorfulCard;
